<template>
  <div>
    <div class="Fuell-Overlay"></div>
    <div class="Fuell-Modal">
      <div class="Fuell-Modal--window with-header centered">
        <div class="Fuell-Modal--header">
          <button
            class="Fuell-Modal--close-button"
            @click="closeModal()"
          >
            <img
              :src="require('@/assets/img/icons/close.svg')"
              alt="close"
            />
          </button>

          <h3
            class="Fuell-Modal--title"
            v-t.preserve="{ path: 'dashboard_account_box_movements_header' }"
          ></h3>
        </div>

        <div
          class="scrollable"
          ref="modalcontainer"
        >
          <template v-if="movements.length > 0">
            <dashboard-movement-row
              v-for="movement in movements"
              :movement="movement"
              :key="movement.id"
            ></dashboard-movement-row>
          </template>

          <div
            class="flex center"
            v-else
          >
            <div class="col-12">
              <p
                v-if="!isCallingMovements"
                v-t="{path: 'dashboard_movements_modal_zero_results'}"
              > </p>
            </div>
          </div>
          <div class="row d-flex justify-content-center">
            <spinner v-if="isCallingMovements" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from '@/components/Commons/Spinner'
import _modalHandlerMixin from '@/components/Commons/_mixins/_modalHandlerMixin'
import DashboardMovementRow from './DashboardMovementRow'
import { segmentTrack } from '@/analytics/segment'
export default {
  name: 'TopUpMovementsModal',
  mixins: [_modalHandlerMixin],
  components: { DashboardMovementRow, Spinner },

  computed: {
    currentPage () {
      return this.$store.getters['DashboardStore/movementsCurrentPage']
    },
    lastPage () {
      return Number.parseInt(this.$store.getters['DashboardStore/movementsLastPage'])
    },
    isCallingMovements () {
      return this.$store.getters['DashboardStore/isCallingMovements']
    },
    movements () {
      return this.$store.getters['DashboardStore/movements'] || []
    },
    currentBalance () {
      return this.$store.getters['CompanyStore/currentCompany'].currentBalance || 0
    }
  },
  mounted () {
    this.pageHandler()
  },
  methods: {
    async fetchMovements () {
      await this.$store.dispatch('DashboardStore/fetchMovements')
      segmentTrack('Movements info viewed', {
        current_balance: this.currentBalance,
        last_top_up_date: this.movements.length > 0 ? this.$moment.utc(this.movements[0].date).format('DD-MM-YYYY hh:mm:ss') : '',
        last_topup_amount: this.movements.length > 0 ? this.movements[0].amount : ''
      })
    },
    nextPage () {
      if (this.isCallingMovements) return
      this.$store.dispatch('DashboardStore/nextMovementsPage')
    },
    pageHandler () {
      const modal = this.$refs.modalcontainer
      modal.onscroll = () => {
        const { scrollTop,
          scrollHeight,
          clientHeight
        } = modal
        let bottom = scrollTop + clientHeight >= scrollHeight - 24

        if (bottom && this.currentPage < this.lastPage) {
          this.nextPage()
        }
      }
    }
  },
  created () {
    this.$store.dispatch('DashboardStore/clearStore', { keep: 'officeBalanceInformation' })
    this.fetchMovements()
  }

}
</script>

<style lang="scss" scoped>
.ModalBox-header {
  position: unset;
}
.Fuell-Modal--window.centered {
  overflow: hidden;
}
.Fuell-Modal--window {
  @media screen and (max-width: 576px) {
    max-height: 100vh;
    height: 100%;
  }
}
</style>
